export const useBtnsAttrs = () => {
    const btns = [
        {
            type: 'ruler',
            label: 'Ruler',
            icon: 'iconMeasureRuler'
        },
        {
            type: 'protractor',
            label: 'Protractor',
            icon: 'iconMeasureProtractor'
        },
        {
            type: 'image',
            label: 'Image',
            icon: 'iconMeasureImage'
        }
    ];
    const getBtn = (type: string) => btns.find((btn) => btn.type === type);

    return { getBtn };
};
